export default __webpack_public_path__ + "static/media/heart-of-steel-schlock-mp4-thumbnail.9dd2f1b2.jpg";